/**
 * Host-pinned agent routing for the Office Add-in (v2).
 *
 * Each Office host maps to a stable AgentCore blueprint id. The blueprint's
 * deployed runtime id (resolved at runtime via /office-addin/agents/{id})
 * is what we actually pass to /agents/{id}/chat. Keep the ids in sync
 * with infrastructure/lambdas/office_addin/seeds.py — the contract test
 * in hostAgentMap.contract.selftest.ts guards the drift.
 *
 * Adding a new host: see docs/office-addin/ADDING_A_NEW_HOST.md.
 */

import type { OfficeHost } from '../office/bootstrap';

/**
 * Blueprint ids MUST match the seeds in office_addin/seeds.py. The resolver
 * endpoint returns the deployed runtime id; we never call /agents/{id}/chat
 * with these values directly.
 */
export const HOST_AGENT_ID: Record<OfficeHost, string | undefined> = {
  Word: 'office-addin-word-agent',
  Excel: 'office-addin-excel-agent',
  PowerPoint: 'office-addin-ppt-agent',
  Outlook: undefined,
  Teams: undefined,
  Meet: undefined,
  Unknown: undefined,
};

export function blueprintIdForHost(host: OfficeHost): string | undefined {
  return HOST_AGENT_ID[host];
}

export function isHostSupported(host: OfficeHost): boolean {
  return Boolean(HOST_AGENT_ID[host]);
}
